<template>
  <li class="glide__slide">
    <div v-if="item.name" class="glide__upper">
      <div class="glide__slide-box">
        <BaseCaption
          v-if="item.name"
          class="glide__title"
          :text="item.name"
          :tag="'h1'"
        />
        <BaseText
          v-if="item.ageAndDealer"
          class="glide__caption"
          :text="item.ageAndDealer"
        />
        <BaseText
          v-if="item.ageCategory"
          class="glide__text"
          :text="item.ageCategory"
        />
      </div>
      <div class="glide__social">
        <BaseText
          class="glide__text  glide__text--mb-hidden"
          :text="'Поділитись малюнком'"
        />
        <SocialBtnsList :id="item.id" :shareBtns="shareBtns" />
      </div>
      <VotingBlock :item="item" />
    </div>
    <div v-if="item.place" class="glide__upper">
      <BaseCaption
        v-if="item.place"
        class="glide__caption"
        :text="item.placeText"
      />
      <BaseText v-if="item.winner" class="glide__text" :text="item.winner" />
    </div>
    <BaseLazyLoadingimg :srcSet="[srcset[0], srcset[1], srcset[2]]" />
    <div class="glide__inner">
      <BaseCaption
        v-if="item.caption"
        class="glide__caption"
        tag="h3"
        :text="item.caption"
      />
      <BaseText v-if="item.descr" class="glide__text" :text="item.descr" />
      <BaseCaption
        v-if="item.jobName"
        class="glide__caption"
        :text="item.jobName"
      />
      <BaseText
        v-if="item.jobDescription"
        class="glide__text"
        :text="item.jobDescription"
      />
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import SocialBtnsList from '~/components/SocialBtnsList'
import VotingBlock from '~/components/VotingBlock'
import HeartIcon from '~/components/_SVG/HeartIcon'

export default {
  data() {
    return {
      shareBtns: ['facebook', 'telegram']
    }
  },
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters('data', ['RESOURCES_URL']),
    srcset() {
      if (this.item.optimizedImages && this.item.optimizedImages.src) {
        return Object.values(this.item.optimizedImages.src)
      } else if (this.item.imgUrl) {
        return [this.item.imgUrl, this.item.imgUrl, this.item.imgUrl]
      } else {
        return []
      }
    }
  },
  components: {
    SocialBtnsList,
    HeartIcon,
    VotingBlock
  }
}
</script>

<style lang="scss">
  .glide__slide-box,
  .glide__inner {
    h1 {
      font-family: $ToyotaBook !important;
    }
    h1,h2 {
      color: #282830 !important;
    }
  }
</style>


// WEBPACK FOOTER //
// components/AppSliderItem.vue